import { type V2 } from "@project-rouge/rg-core";

export function GetPointByDistanceAndDirection(point: V2, distance: number, radian: number): V2 {
  return [point[0] + distance * Math.cos(radian), point[1] + distance * Math.sin(radian)];
}
